module.exports = __webpack_public_path__ + "static/media/curling.cd9d79f3.svg";